module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row",
    class: {
      hide: _vm.step > 0
    },
    attrs: {
      "id": "intro"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('h2', {
    staticClass: "h1"
  }, [_vm._v("Send emails to recipients via CSV")]), _vm._v(" "), _c('ol', [_c('li', [_vm._v("Verify your email")]), _vm._v(" "), _c('li', [_vm._v("Upload CSV")]), _vm._v(" "), _c('li', [_vm._v("Copy and Paste or write your email text")]), _vm._v(" "), _c('li', [_vm._v("Add variables from your CSV columns")]), _vm._v(" "), _c('li', [_vm._v("Send to all recipients")]), _vm._v(" "), _c('li', [_vm._v("You may send " + _vm._s(_vm.numAvailable) + " emails")])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.step > 0) ? _c('div', {
    staticClass: "progress"
  }, [_c('div', {
    staticClass: "progress-bar bg-success",
    style: (_vm.getProgress),
    attrs: {
      "role": "progressbar",
      "aria-valuenow": "0",
      "aria-valuemin": "0",
      "aria-valuemax": "100"
    }
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row",
    class: {
      'success': _vm.step > 0
    }
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    class: _vm.step < 0 ? 'col-md-8' : 'col-md-7'
  }, [_c('verify', {
    on: {
      "step": _vm.setStep,
      "setemail": _vm.setEmail
    }
  })], 1), _vm._v(" "), _c('div', {
    class: _vm.step > 0 ? 'col-md-1' : 'hidden'
  }, [(_vm.step > 0) ? _c('i', {
    staticClass: "fa fa-check pull-right fa-large"
  }) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    class: {
      'success': _vm.step > 1
    }
  }, [_vm._m(2), _vm._v(" "), (_vm.file.name) ? _c('div', {
    staticClass: "col-sm-7"
  }, [_vm._v("\n      " + _vm._s(_vm.file.name) + " "), _c('i', {
    staticClass: "fa fa-trash-o",
    on: {
      "click": _vm.removeFile
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-sm-1"
  }, [(_vm.step > 1) ? _c('i', {
    staticClass: "fa fa-check pull-right fa-larger pull-right"
  }) : _vm._e()])]), _vm._v(" "), (_vm.step == 1) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', [_c('div', {
    staticClass: "dropzone-area",
    class: {
      'dropzone-hover': _vm.hovering
    },
    on: {
      "dragenter": function($event) {
        _vm.hovering = true
      },
      "dragleave": function($event) {
        _vm.hovering = false
      }
    }
  }, [_c('div', {
    staticClass: "dropzone-text"
  }, [_c('span', {
    staticClass: "dropzone-title"
  }, [_vm._v("Drop CSV here or click to select")]), _vm._v(" "), (_vm.info) ? _c('span', {
    staticClass: "dropzone-info"
  }, [_vm._v(_vm._s(_vm.info))]) : _vm._e()]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file"
    },
    on: {
      "change": _vm.onFileChange
    }
  })])]), _vm._v(" "), (_vm.noEmailFound && !_vm.emailColumn) ? _c('div', {
    staticClass: "alert alert-warning padded tcenter margined"
  }, [(_vm.emailCols.length > 1) ? _c('div', [_vm._v("\n          More than one column header included the word email, please select which one you want to use.\n        ")]) : _c('div', [_vm._v("\n          No Email column was found. You must have the keyword \"email\" in one column header. Please select one or upload a new CSV.\n        ")]), _vm._v(" "), _c('ul', {
    staticClass: "select-email"
  }, _vm._l((_vm.selectCols), function(col) {
    return _c('li', {
      staticClass: "cols",
      on: {
        "click": function($event) {
          _vm.setEmailColum(col)
        }
      }
    }, [_vm._v(_vm._s(col) + " "), _c('i', {
      staticClass: "fa fa-check"
    })])
  }))]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row",
    class: {
      'success': _vm.step > 2
    }
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "col-sm-1"
  }, [(_vm.step > 2) ? _c('i', {
    staticClass: "fa fa-check pull-right"
  }) : _vm._e()])]), _vm._v(" "), (_vm.step > 1 && _vm.step < 4) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "text"
  }, [_c('h5', [_vm._v("Live Preview "), _c('button', {
    staticClass: "pull-right",
    on: {
      "click": function($event) {
        _vm.toggleEdit()
      }
    }
  }, [_vm._v("Edit "), _c('span', [_c('i', {
    staticClass: "fa",
    class: {
      'fa-pencil-square-o': !_vm.edit, 'fa-pencil-square': _vm.edit
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_vm._v("From:  " + _vm._s(_vm.email))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_vm._v("To: " + _vm._s(_vm.currentEmail))]), _vm._v(" "), (!_vm.edit) ? _c('div', {
    staticClass: "col-md-12",
    on: {
      "click": function($event) {
        _vm.edit = true
      }
    }
  }, [_vm._v("Subject: " + _vm._s(_vm.currentSubject))]) : _vm._e(), _vm._v(" "), (_vm.edit) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.subject),
      expression: "subject"
    }],
    staticClass: "col-md-12",
    attrs: {
      "type": "text",
      "placeholder": "Your Subject"
    },
    domProps: {
      "value": _vm._s(_vm.subject)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.subject = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.edit) ? _c('div', {
    staticClass: "current-text",
    domProps: {
      "innerHTML": _vm._s(_vm.currentText)
    },
    on: {
      "click": function($event) {
        _vm.toggleEdit(true)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.edit) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.text),
      expression: "text"
    }],
    attrs: {
      "id": "editText"
    },
    domProps: {
      "value": _vm._s(_vm.text)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.text = $event.target.value
      }
    }
  }) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 table-holder"
  }, [_c('div', {
    staticClass: "alert alert-info"
  }, [_c('info'), _vm._v("Click on a column header to add the variable to your email text.\n      ")], 1), _vm._v(" "), _c('table', {
    staticClass: "table table-hover table-border"
  }, [_c('thead', [_c('tr', _vm._l((_vm.cols), function(col) {
    return _c('th', {
      on: {
        "click": function($event) {
          _vm.addVariable(col)
        }
      }
    }, [_vm._v(_vm._s(col) + "\n            ")])
  }))]), _vm._v(" "), _c('tbody', _vm._l((_vm.rows), function(row) {
    return _c('tr', {
      class: {
        'selected': row == _vm.currentRow
      },
      on: {
        "click": function($event) {
          _vm.currentRow = row;
          _vm.edit = false
        }
      }
    }, _vm._l((row), function(col) {
      return _c('td', [_vm._v(_vm._s(col))])
    }))
  }))])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row",
    class: {
      'success': _vm.step == 4
    }
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [(_vm.step > 2 && _vm.step < 4) ? _c('smtp-info', {
    attrs: {
      "sending": _vm.sending,
      "errors": _vm.errors,
      "num-available": _vm.numAvailable,
      "email": _vm.email
    },
    on: {
      "error": _vm.catchError,
      "sendemail": _vm.sendEmail
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-1"
  }, [(_vm.step > 3) ? _c('i', {
    staticClass: "fa fa-check pull-right"
  }) : _vm._e()])]), _vm._v(" "), (_vm.msg) ? _c('div', {
    staticClass: "alert alert-info"
  }, [_vm._v(_vm._s(_vm.msg))]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6"
  }, [_c('h1', [_vm._v("CSV 2 Email")]), _vm._v("\n        Have a spreadsheet with emails that you'd like to send the same templated message to? With this tool you can\n        easily send emails everyone to in your spreadsheet, and add variables to your text. These variables will be\n        replaced by the values in each row. If you have a column named Order No, then you can put that into your email\n        wherever you want it with the text {order-no}. Ex: Your order #{order-no} was successfully received.\n    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-4"
  }, [_c('h3', [_vm._v("Step 1. Verify your email")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-4"
  }, [_c('h3', {
    staticClass: "pull-left"
  }, [_vm._v("Step 2. Upload CSV ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-11"
  }, [_c('h3', [_vm._v("Step 3. Update Email Text")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-4"
  }, [_c('h3', [_vm._v("Step 4. Send")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-21610219!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/FileUpload.vue
// module id = 79
// module chunks = 2